import { thumb } from "../lib/site";
import { Link } from "react-router-dom";
import { PROJECTS } from "../data/content";
import { PRICING } from "../data/pricing";

/**
 * Starting prices and three recent projects, shared by service, city and
 * industry pages. `markets` picks which price columns to show.
 */
export default function PricingProof({ markets = ["IN", "US", "AE"], heading = "Pricing & recent work", showProjects = true }) {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-20 sm:px-8 lg:px-16" data-testid="pricing-proof">
      <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">{heading}</h2>
      <div className={`mt-8 grid gap-5 ${markets.length > 1 ? "md:grid-cols-3" : "md:grid-cols-2"}`}>
        {markets.map((code) => {
          const p = PRICING[code];
          return (
            <div key={code} className="rounded-3xl border border-white/10 bg-ink p-7">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-ember">{p.label}</p>
              <p className="mt-4 font-display text-3xl font-black">from {p.website}</p>
              <p className="mt-1 text-sm text-white/50">website build, one-time</p>
              <p className="mt-4 font-display text-xl font-bold">from {p.growth}<span className="text-sm text-white/50">/month</span></p>
              <p className="mt-1 text-sm text-white/50">optional growth plan</p>
            </div>
          );
        })}
        {markets.length === 1 && (
          <div className="rounded-3xl border border-white/10 bg-ink p-7">
            <p className="text-sm leading-relaxed text-white/60">
              Every price is a starting point. You get a fixed quote, scope and timeline in writing before any work starts. Selling abroad too? See prices for the{" "}
              <Link to="/website-development-usa/" className="text-ember underline-offset-2 hover:underline">USA</Link> and{" "}
              <Link to="/website-development-dubai/" className="text-ember underline-offset-2 hover:underline">Dubai</Link>.
            </p>
          </div>
        )}
      </div>
      <p className="mt-4 text-sm text-white/50">
        <Link to="/pricing/" className="font-semibold text-ember underline-offset-2 hover:underline">See full pricing</Link>
      </p>
      {showProjects && <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {PROJECTS.slice(0, 3).map((p) => (
          <Link key={p.slug} to={`/projects/${p.slug}/`} className="group overflow-hidden rounded-3xl border border-white/10 bg-ink transition-colors hover:border-ember/40">
            <img src={thumb(p.image)} alt={`${p.name} website built by Grotech Web`} width="800" height="500" loading="lazy" decoding="async" className="aspect-[16/10] w-full object-cover" />
            <div className="p-6">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ember">{p.industry}</p>
              <p className="mt-2 font-display text-lg font-bold group-hover:text-ember">{p.name}</p>
            </div>
          </Link>
        ))}
      </div>}
    </section>
  );
}
